// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3812":"50412a5e","4772":"fc24e128","5133":"095f31fc","7920":"50412a5e"}[chunkId] + ".chunk.css";
};